<template>
    <div class="help">
        <div class="container">
            <h1 class="title">How to cite</h1>

            <div class="overview">
                PreBINDS: An Interactive Web Tool to Create Appropriate Datasets for Predicting Compound-Protein Interactions. Ikeda, K., Doi, T., Ikeda, M., Tomii, K. Front Mol Biosci. 8:758480 (2021).  PMID: 34938773, PMCID: PMC8685504, doi: <a href="https://www.frontiersin.org/articles/10.3389/fmolb.2021.758480/">10.3389/fmolb.2021.758480</a>.
            </div>

        </div>
    </div>


</template>

<script>

export default {
    name: 'Help',
    components: {
    },
    data: function() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped>
.container {
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    font-size: 18px;
}

.block {
    padding: 30px;
    border: solid 1px;
    margin-top: 100px;
    margin-bottom: 100px;
}

.description {
    text-align: left;
}

.capture {
    text-aling:center;
}

.capture img {
    margin-top: 30px;
    margin-bottom: 30px;
    margin-left: 20%;
    margin-right: auto;
    width: 60%;
}
</style>